import React from 'react';


class Candles extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div style={{width: 300}}>{
        this.props.candlesTypes ?
        this.props.candles.map((candle_type, i) => 
          <img key={i} style={{display: 'inline-block', width: 60, height: 60}} src={this.props.candlesTypes[candle_type]} alt="Candle Icon" />
        ) : null
      }</div>
    );
  };
};

export default Candles;



// WEBPACK FOOTER //
// src/components/Candles/Candles.js